import Navbar from "./components/NavBar/navbar";
import Intro from './components/Intro/intro';
import About from "./components/About/about";
import Portfolio from "./components/Portfolio/portfolio";
import Clients from "./components/Clients/clients";
import Footer from "./components/Footer/footer";

function App() {
  return (
    <div className="App">
      <Navbar/>
      <Intro/>
      <About/>
      <Portfolio/>
      <Clients/>
      <Footer/>
    </div>
  );
}

export default App;
